import * as d3 from 'd3';
import {
  DEFAULT_DEFECT_RECT_H,
  DEFAULT_DEFECT_RECT_W
} from '@/utils/defect/defaultDefectDrawerRect';

function DefectDrawer(options){

  const self = this;

  this.options = options || {};
  this.options.x = options.x || null;
  this.options.y = options.y || null;
  this.options.h = options.h || 512; // thermal image height
  this.options.w = options.w || 640; // thermal image width
  this.options.rect_h = options.rect_h || DEFAULT_DEFECT_RECT_H;
  this.options.rect_w = options.rect_w || DEFAULT_DEFECT_RECT_W;
  this.options.addTo = options.addTo || 'body'; // Where to add the SVG (a css selector
  this.options.addBorderRect = options.addBorderRect || false;
  this.options.text_m = options.text_m || 10;
  this.options.thermo_fn = options.thermo_fn || {};
  this.options.text_y_pos_corr = 10;
  this.eventListener = options.eventListener || {};
  this.store = options.store || null; // Vuex store 추가
  /** true면 SVG 온도 텍스트 숨기고 onThermoHudUpdate로 화면 고정 HUD에 위임 */
  this.options.screenSpaceThermoHud = options.screenSpaceThermoHud === true;
  this.options.onThermoHudUpdate = options.onThermoHudUpdate || null;

  this.options.rectOpt = {
    dbWidth: 9,
    dsRadius: 4
  };

  this.state = {
    type: 'Table',
    color: '#008000',
    count: 0,
    class: 'rect-table',
    id: 'Table-0'
  };

  /** 드래그 중 온도 계산·라벨 갱신을 rAF로 묶어 메인 스레드 부하 완화 */
  this._thermoRafId = null;

  this.svg = d3.select(this.options.addTo)
    .append('svg')
    .attr('height', this.options.h)
    .attr('width', this.options.w)
    .attr('class', 'display-svg');

  if (this.options.addBorderRect) {
    this.svg.append('rect')
      .attr('height', this.options.h)
      .attr('width', this.options.w)
      .attr('stroke', 'black')
      .attr('stroke-width', 4)
      .attr('opacity', 0.25)
      .attr('fill-opacity', 0.0)
      .attr('class', 'border-rect');
  }

  this.Rect = { // Current Selection
    'g': null,
    'r': null,
    'x0': this.options.x !== null ? this.options.x : (this.options.w - this.options.rect_w) / 2,
    'y0': this.options.y !== null ? this.options.y : (this.options.h - this.options.rect_h) / 2,
    'width': this.options.rect_w,
    'height': this.options.rect_h
  };

  this.Text = {
    'g' : null,
    'avrT' : null,
    'minT' : null,
    'maxT' : null,
    'x0' : null,
    'y0' : null
  };

  /** 부모 뷰포트 줌 k — 온도 라벨은 1/k 로 상쇄해 화면 크기 유지 */
  this._labelScreenSpaceZoomK = 1;
  this._labelAnchorX = null;
  this._labelAnchorY = null;

  this.inActiveRectG = this.svg
    .append('g')
    .attr('class', 'rect-group inactive');

  this.rectG = this.svg
    .append('g')
    .attr('class', 'rect-group');

  this.Rect.g = self.rectG
    .append('g')
    .attr('class', 'g-rect ' + self.state.id);

  this.Rect.r = this.Rect.g
    .append('rect')
    .attr('x', this.Rect.x0)
    .attr('y', this.Rect.y0)
    .attr('width', this.options.rect_w)
    .attr('height', this.options.rect_h)
    .attr('stroke', '#008000')
    .attr('stroke-width', 3)
    // fill:none 이면 내부 hit-test가 안 되어 박스 안 드래그가 불가
    .attr('fill', 'rgba(57, 255, 20, 0.04)')
    .attr('opacity', 1)
    .attr('class', 'rect-main ' + self.state.class + ' ' + self.state.id);

  this.Text.g = this.svg.append('g')
    .attr('class', 'text-group');
  if (this.options.screenSpaceThermoHud) {
    this.Text.g.style('display', 'none');
  }

  const textXPos = this.Rect.x0 + this.options.rect_w + this.options.text_m;

  const thermo = this.options.thermo_fn ? this.options.thermo_fn({
    x: this.Rect.x0,
    y: this.Rect.y0,
    w: this.Rect.width,
    h: this.Rect.height
  }) : null;

  const textGroups = this.makeText(textXPos, this.Rect.y0, 'text-main', thermo);
  this.Text.maxT = textGroups.maxText;
  this.Text.minT = textGroups.minText;
  this.Text.avrT = textGroups.avrText;

  this.setActive(self.state.id);
  this.transformRect();

  // Load methods for behaviors
  this.makeAddRect(); // Add Rectangle Methods
  // this.makeDragBehavior();

  // Dragging Behavior - account for both addRect and pan.
  // this.svg.call(
  //   d3.drag()
  //   .on('start', self.dragBehavior.start)
  //   .on('drag', self.dragBehavior.drag)
  //   .on('end', self.dragBehavior.end)
  // );

  // d3.select('body').on('keydown', this.keydownEventHandlers);
}


DefectDrawer.prototype.reset = function(options){

  options = options || {};
  if (options.w != null && options.w > 0) {
    this.options.w = options.w;
  }
  if (options.h != null && options.h > 0) {
    this.options.h = options.h;
  }
  this.svg
    .attr('width', this.options.w)
    .attr('height', this.options.h);
  const borderRect = this.svg.select('rect.border-rect');
  if (!borderRect.empty()) {
    borderRect.attr('width', this.options.w).attr('height', this.options.h);
  }

  this.clearAll();
  this.options.x = options.x !== undefined ? options.x : null;
  this.options.y = options.y !== undefined ? options.y : null;
  this.options.rect_h = options.rect_h || DEFAULT_DEFECT_RECT_H;
  this.options.rect_w = options.rect_w || DEFAULT_DEFECT_RECT_W;

  this.Rect.x0 = this.options.x !== null ? this.options.x : (this.options.w - this.options.rect_w) / 2;
  this.Rect.y0 = this.options.y !== null ? this.options.y : (this.options.h - this.options.rect_h) / 2;
  this.Rect.width = this.options.rect_w;
  this.Rect.height = this.options.rect_h;

  this.Rect.r = this.Rect.g
    .append('rect')
    .attr('x', this.Rect.x0)
    .attr('y', this.Rect.y0)
    .attr('width', this.options.rect_w)
    .attr('height', this.options.rect_h)
    .attr('stroke', '#008000')
    .attr('stroke-width', 2)
    .attr('fill', 'rgba(57, 255, 20, 0.04)')
    .attr('opacity', 1)
    .attr('class', 'rect-main ' + this.state.class + ' ' + this.state.id);

  const textXPos = this.Rect.x0 + this.options.rect_w + this.options.text_m;

  const thermo = this.options.thermo_fn ? this.options.thermo_fn({
    x: this.Rect.x0,
    y: this.Rect.y0,
    w: this.Rect.width,
    h: this.Rect.height
  }) : null;

  const textGroups = this.makeText(textXPos, this.Rect.y0, 'text-main', thermo);
  this.Text.maxT = textGroups.maxText;
  this.Text.minT = textGroups.minText;
  this.Text.avrT = textGroups.avrText;

  this.setActive(this.state.id);
  this.transformRect();

  // 드래그 기능 다시 등록
  this.makeAddRect();
};

DefectDrawer.prototype.clearRect = function(){
  d3.selectAll('rect.rect-main').remove();
  d3.selectAll('rect.rect-sub').remove();
  d3.selectAll('rect.rectCorner').remove();
  d3.selectAll('rect.rectEdge').remove();
};

DefectDrawer.prototype.clearText = function(){
  d3.selectAll('text.text-main').remove();
  d3.selectAll('text.text-sub').remove();
};

DefectDrawer.prototype.clearAll = function(){
  if (this._thermoRafId != null) {
    cancelAnimationFrame(this._thermoRafId);
    this._thermoRafId = null;
  }
  this.clearRect();
  this.clearText();
};

/**
 * 열화상 위 온도 라벨: 어두운/밝은 배경 모두에서 읽히도록 스트로크 아웃라인 + 채움.
 * (SVG text는 fill 미지정 시 기본 검정 → 검은 배경에서 사라짐; 기존 attr('color')는 SVG에서 무시됨)
 */
DefectDrawer.prototype.styleThermoLabel = function (selection) {
  selection
    .attr('fill', '#f1f5f9')
    .attr('stroke', '#0f172a')
    .attr('stroke-width', 2.5)
    .attr('stroke-linejoin', 'round')
    .attr('paint-order', 'stroke fill')
    .style('paint-order', 'stroke fill');
};

/**
 * 뷰포트 줌 k에 맞춰 온도 라벨만 화면 크기로 유지 (결함 사각형은 확대됨).
 * screenSpaceThermoHud 모드에서는 HTML HUD가 담당하므로 no-op.
 * @param {number} zoomK
 */
DefectDrawer.prototype.setScreenSpaceLabelScale = function (zoomK) {
  if (this.options.screenSpaceThermoHud) {
    return;
  }
  const k = Number(zoomK);
  this._labelScreenSpaceZoomK = Number.isFinite(k) && k > 0 ? k : 1;
  this.applyLabelScreenSpaceTransform();
};

/**
 * 라벨 앵커 기준으로 scale(1/k) — 부모 zoom과 곱해 글자·박스 크기가 일정해짐.
 */
DefectDrawer.prototype.applyLabelScreenSpaceTransform = function () {
  if (this.options.screenSpaceThermoHud) {
    return;
  }
  if (!this.Text || !this.Text.g) {
    return;
  }
  const k = this._labelScreenSpaceZoomK || 1;
  const inv = 1 / k;
  let ax = this._labelAnchorX;
  let ay = this._labelAnchorY;
  if ((ax == null || ay == null) && this.Text.maxT) {
    ax = Number(this.Text.maxT.attr('x'));
    ay = Number(this.Text.maxT.attr('y'));
  }
  if (!Number.isFinite(ax)) ax = 0;
  if (!Number.isFinite(ay)) ay = 0;
  this._labelAnchorX = ax;
  this._labelAnchorY = ay;
  this.Text.g.attr(
    'transform',
    'translate(' + ax + ',' + ay + ') scale(' + inv + ') translate(' + -ax + ',' + -ay + ')'
  );
};

DefectDrawer.prototype.setLabelAnchor = function (xPos, yPos, thermo) {
  this._labelAnchorX = Number(xPos) || 0;
  this._labelAnchorY = Number(yPos) || 0;
  if (thermo != null) {
    this._lastThermo = thermo;
  }
  this.applyLabelScreenSpaceTransform();
  this.notifyThermoHud(thermo != null ? thermo : this._lastThermo);
};

/**
 * 화면 고정 HUD용 콜백 (이미지 픽셀 좌표 + 온도).
 */
DefectDrawer.prototype.notifyThermoHud = function (thermo) {
  if (!this.options.screenSpaceThermoHud) {
    return;
  }
  if (typeof this.options.onThermoHudUpdate !== 'function') {
    return;
  }
  const t = thermo || this._lastThermo || null;
  this.options.onThermoHudUpdate({
    imageX: this._labelAnchorX ?? 0,
    imageY: this._labelAnchorY ?? 0,
    rect: {
      x: this.Rect.x0,
      y: this.Rect.y0,
      w: this.Rect.width,
      h: this.Rect.height
    },
    max: t && t.max != null ? t.max : '-',
    min: t && t.min != null ? t.min : '-',
    avr: t && t.avr != null ? t.avr : '-',
    visible: true
  });
};

DefectDrawer.prototype.mouseOffset = function() {
  // Get the current location of mouse along with other info (to be added to later)
  return d3.mouse(this.rectG.node());
};

DefectDrawer.prototype.makeText = function(xPos, yPos, className, thermo){
  const maxText = this.Text.g
    .append('text')
    .attr('x', xPos)
    .attr('y', yPos + this.options.text_y_pos_corr)
    .attr('class', className + ' max-t defect-thermo-label ' + this.state.id)
    .text('max: ' + (thermo !== null && thermo !== undefined ? thermo.max : '-'));
  this.styleThermoLabel(maxText);

  const minText = this.Text.g
    .append('text')
    .attr('x', xPos)
    .attr('y', yPos + this.options.text_y_pos_corr)
    .attr('dy', '1em')
    .attr('class', className + ' min-t defect-thermo-label ' + this.state.id)
    .text('min: ' + (thermo !== null && thermo !== undefined ? thermo.min : '-'));
  this.styleThermoLabel(minText);

  const avrText = this.Text.g
    .append('text')
    .attr('x', xPos)
    .attr('y', yPos + this.options.text_y_pos_corr)
    .attr('dy', '2em')
    .attr('class', className + ' avr-t defect-thermo-label ' + this.state.id)
    .text('avr: ' + (thermo !== null && thermo !== undefined ? thermo.avr : '-'));
  this.styleThermoLabel(avrText);

  this.setLabelAnchor(xPos, yPos + this.options.text_y_pos_corr, thermo);

  return {
    maxText: maxText,
    minText: minText,
    avrText: avrText
  };
};

DefectDrawer.prototype.moveMainText = function(xPos, yPos, width, thermo){
  const self = this;
  const x = xPos + width + this.options.text_m;
  const y = yPos + this.options.text_y_pos_corr;
  const maxSel = d3.select('.max-t');
  const minSel = d3.select('.min-t');
  const avrSel = d3.select('.avr-t');
  maxSel.attr('x', x).attr('y', y).text('max: ' + (thermo !== null ? thermo.max : '-'));
  self.styleThermoLabel(maxSel);
  minSel.attr('x', x).attr('y', y).text('min: ' + (thermo !== null ? thermo.min : '-'));
  self.styleThermoLabel(minSel);
  avrSel.attr('x', x).attr('y', y).text('avr: ' + (thermo !== null ? thermo.avr : '-'));
  self.styleThermoLabel(avrSel);
  self.setLabelAnchor(x, y, thermo);
};

DefectDrawer.prototype.makeAddRect = function () {
  // Methods for adding rectangles to the svg.
  const self = this;
  let x0 = self.Rect.x0, y0 = self.Rect.y0;

  const start = function () {
    //Add a rectangle
    // 1. Get mouse location in SVG

    if(self.Rect.r !== null){
      return;
    }

    const m = self.mouseOffset();
    x0 = m[0];
    y0 = m[1];

    self.Rect.x0 = x0;
    self.Rect.y0 = y0;

    self.Rect.g = self.rectG
      .append('g')
      .attr('class', 'g-rect ' + self.state.id);

    self.Rect.r = self.Rect.g
      .append('rect')
      .attr('x', x0)
      .attr('y', y0)
      .attr('width', 1)
      .attr('height', 1)
      .attr('stroke', '#008000')
      .attr('stroke-width', 2)
      .attr('fill', 'rgba(57, 255, 20, 0.04)')
      .attr('opacity', 1)
      .attr('class', 'rect-main ' + self.state.class + ' ' + self.state.id);

    self.setActive(self.state.id);
  };

  const drag = function () {
    // What to do when mouse is dragged
    // 1. Get the new mouse position
    const m = self.mouseOffset();
    // 2. Update the attributes of the rectangle
    self.Rect.x0 = Math.min(self.Rect.x0, m[0]);
    self.Rect.y0 = Math.min(self.Rect.y0, m[1]);
    self.Rect.width = Math.abs(x0 - m[0]) ;
    self.Rect.height = Math.abs(y0 - m[1]) ;
    self.Rect.r.attr('x', self.Rect.x0)
      .attr('y', self.Rect.y0)
      .attr('width', self.Rect.width)
      .attr('height', self.Rect.height);
  };
  const end = function () {
    // What to do on mouseup
    // Add Rectangle Transformation Methods
    self.transformRect();
    // Clear out rect.

  };

  self.addRect = {
    start: start,
    drag: drag,
    end: end
  };
};


DefectDrawer.prototype.keydownEventHandlers = function () {
  // Event handler for keydown events
  const self = this;

  // Press 'Delete' to remove all active groups.
  if (d3.event.key === 'Delete') {
    d3.selectAll('.active').remove();
    // self.Rect.r = null;
  }
};

DefectDrawer.prototype.makeDragBehavior = function () {
  const self = this;
  let set = false; // Disable retroactive re-fitting

  const start = function () {
    if (!d3.event.sourceEvent.shiftKey) {
      self.addRect.start();
      set = true;
    }
    if (d3.event.sourceEvent.shiftKey) {
      null;
    }
  };

  const drag = function () {
    if (set && !(d3.event.sourceEvent.shiftKey)) {
      self.addRect.drag();
    }
    if (d3.event.sourceEvent.shiftKey) {
      self.zoomPan.pan();
    }
  };

  const end = function () {
    if (set &
      !(d3.event.sourceEvent.shiftKey)) {
      self.addRect.end();
      set = false;
    }
    if (d3.event.sourceEvent.shiftKey) {
      null;
    }
  };

  self.dragBehavior = {
    start: start,
    drag: drag,
    end: end
  };
};

/**********************************
Dragging and resizing rectangles.
**********************************/
function contains(a, obj) {
  // See: https://stackoverflow.com/questions/237104/how-do-i-check-if-an-array-includes-an-object-in-javascript
  for (let i = 0; i < a.length; i++) {
    if (a[i] === obj) {
      return true;
    }
  }
  return false;
}

function clone(selector) {
  // Clone a d3 selection.
  // Source: https://stackoverflow.com/questions/39477740/copy-and-insert-in-d3-selection
  const node = d3.select(selector).node();
  return d3.select(node.parentNode.insertBefore(node.cloneNode(true), node.nextSibling));
}

DefectDrawer.prototype.transformRect = function () {
  const self = this;
  let groupClass, debug, g, r, p, dbWidth, activeG;

  const main = function () {

    r = self.Rect.r;
    g = self.Rect.g;
    dbWidth = self.options.rectOpt.dbWidth;
    // Set common class
    groupClass = self.state.id;
    debug = self.options.debug ? (' debug') : ('');

    // Add data to the group element
    const rBB = r.node().getBBox();
    p = {
      x: rBB.x,
      y: rBB.y,
      w: rBB.width,
      h: rBB.height,
      id: groupClass
    };
    g = g.data([p]);

    // Add the hidden bounding rectangles
    makeRectEdgeCorner();
  };

  main();

  function setCoordsData(d) {
    // Set the coordinates of a rectangle-group

    // console.log('set coords data:', d);

    const children = d3.selectAll('g.active.' + d.id);

    // Main Rectangle
    children.select('rect.rect-main')
      .attr('x', d.x)
      .attr('y', d.y)
      .attr('width', d.w)
      .attr('height', d.h);

    if (self.options.debug) {
      console.log('[DEFECT DRAWER] 사각형 크기 업데이트:', {
        x: d.x,
        y: d.y,
        width: d.w,
        height: d.h,
        id: d.id
      });
    }

    // self.Rect 객체도 함께 업데이트
    self.Rect.x0 = d.x;
    self.Rect.y0 = d.y;
    self.Rect.width = d.w;
    self.Rect.height = d.h;

    // 픽셀 순회(getMinMaxAverage)·이벤트버스·Vuex가 매 mousemove마다 돌면 드래그가 둔하게 느껴짐 → 프레임당 1회로 합침
    if (typeof self.options.thermo_fn === 'function') {
      if (self._thermoRafId != null) {
        cancelAnimationFrame(self._thermoRafId);
      }
      self._thermoRafId = requestAnimationFrame(function () {
        self._thermoRafId = null;
        const bx = self.Rect.x0;
        const by = self.Rect.y0;
        const bw = self.Rect.width;
        const bh = self.Rect.height;
        const thermo = self.options.thermo_fn({
          x: bx,
          y: by,
          w: bw,
          h: bh
        });
        self.moveMainText(bx, by, bw, thermo);
      });
    }

    // rectEdge.left
    children.select('rect.rectEdge.rectEdge-left')
      .attr('x', d.x - (dbWidth / 2))
      .attr('y', d.y + (dbWidth / 2))
      .attr('width', dbWidth)
      .attr('height', Math.abs(d.h - dbWidth));

    // rectEdge.right
    children.select('rect.rectEdge.rectEdge-right')
      .attr('x', d.x + d.w - (dbWidth / 2))
      .attr('y', d.y + (dbWidth / 2))
      .attr('width', dbWidth)
      .attr('height', Math.abs(d.h - dbWidth));

    // rectEdge.top
    children.select('rect.rectEdge.rectEdge-top')
      .attr('x', d.x + (dbWidth / 2))
      .attr('y', d.y - (dbWidth / 2))
      .attr('width', Math.abs(d.w - dbWidth))
      .attr('height', dbWidth);

    // rectEdge.bottom
    children.select('rect.rectEdge.rectEdge-bottom')
      .attr('x', d.x + (dbWidth / 2))
      .attr('y', d.y + d.h - (dbWidth / 2))
      .attr('width', Math.abs(d.w - dbWidth))
      .attr('height', dbWidth);

    // rectCorner.topleft
    children.select('rect.rectCorner.rectCorner-topleft')
      .attr('x', d.x - (dbWidth / 2))
      .attr('y', d.y - (dbWidth / 2));

    // rectCorner.topright
    children.select('rect.rectCorner.rectCorner-topright')
      .attr('x', d.x + d.w - (dbWidth / 2))
      .attr('y', d.y - (dbWidth / 2));

    // rectCorner.botleft
    children.select('rect.rectCorner.rectCorner-botleft')
      .attr('x', d.x - (dbWidth / 2))
      .attr('y', d.y + d.h - (dbWidth / 2));

    // rectCorner.botright
    children.select('rect.rectCorner.rectCorner-botright')
      .attr('x', d.x + d.w - (dbWidth / 2))
      .attr('y', d.y + d.h - (dbWidth / 2));

  }

  // Add move and resize methods
  function moveRect() {
    // Move the rectangle by dragging edges
    let activeG;

    function start() {
      self.setActive(groupClass);
      self.svg.style('cursor', 'move');
      activeG = d3.selectAll('g.active');
    }

    function drag() {

      activeG.each(
        (d, i) => {
          // Alter Parameters
          d.x = Math.max(0, Math.min(self.options.w - d.w, d.x + d3.event.dx));
          d.y = Math.max(0, Math.min(self.options.h - d.h, d.y + d3.event.dy));

          // Set Coordinates
          setCoordsData(d);
        }
      );
    }

    function end() {
      // Undo formatting
      self.svg.style('cursor', 'default');
    }

    // What to do on drag
    const dragcontainer = d3.drag()
      .on('start', start)
      .on('drag', drag)
      .on('end', end);

    return {
      drag: dragcontainer
    };
  }

  function resizeRect() {
    // Resize the rectangle by dragging the corners

    function getDragCorners() {
      return {
        topleft: function (d, bb0, m) {
          d.x = Math.max(0, Math.min(bb0.x + bb0.width, m[0]));
          d.y = Math.max(0, Math.min(bb0.y + bb0.height, m[1]));
          d.w = (m[0] > 0) ? Math.min(Math.abs(self.options.w - d.x), Math.abs(bb0.x + bb0.width - m[0])) : d.w;
          d.h = (m[1] > 0) ? Math.min(Math.abs(self.options.h - d.y), Math.abs(bb0.y + bb0.height - m[1])) : d.h;
        },

        topright: function (d, bb0, m) {
          d.x = Math.max(0, Math.min(bb0.x, m[0]));
          d.y = Math.max(0, Math.min(bb0.y + bb0.height, m[1]));
          d.w = (m[0] > 0) ? Math.min(Math.abs(self.options.w - d.x), Math.abs(bb0.x - m[0])) : d.w;
          d.h = (m[1] > 0) ? Math.min(Math.abs(self.options.h - d.y), Math.abs(bb0.y + bb0.height - m[1])) : d.h;
        },

        botleft: function (d, bb0, m) {
          d.x = Math.max(0, Math.min(bb0.x + bb0.width, m[0]));
          d.y = Math.max(0, Math.min(bb0.y, m[1]));
          d.w = (m[0] > 0) ? Math.min(Math.abs(self.options.w - d.x), Math.abs(bb0.x + bb0.width - m[0])) : d.w;
          d.h = (m[1] > 0) ? Math.min(Math.abs(self.options.h - d.y), Math.abs(bb0.y - m[1])) : d.h;
        },

        botright: function (d, bb0, m) {
          d.x = Math.max(0, Math.min(bb0.x, m[0]));
          d.y = Math.max(0, Math.min(bb0.y, m[1]));
          d.w = (m[0] > 0) ? Math.min(Math.abs(self.options.w - d.x), Math.abs(bb0.x - m[0])) : d.w;
          d.h = (m[1] > 0) ? Math.min(Math.abs(self.options.h - d.y), Math.abs(bb0.y - m[1])) : d.h;
        }
      };
    }

    const makeContainer = function (id) {
      // Make a container, which depends on the corner (specified by `id`)
      let cursor, bb0;

      // Get the correct transformation function
      const dragCorners = getDragCorners()[id];
      // Get the correct cursor
      if (contains(['topleft', 'botright'], id)) {
        cursor = 'nwse-resize';
      } else {
        cursor = 'nesw-resize';
      }

      const start = function () {
        // Set the present group to be active
        self.setActive(groupClass, false);
        // Get the active groups
        activeG = d3.selectAll('g.active');
        // Get the initial Bounding Box
        bb0 = r.node().getBBox();
        // Display correct cursor tip
        self.svg.style('cursor', cursor);
      };

      const drag = function () {
        // Mouse position
        const m = d3.mouse(self.rectG.node());
        // Update parameters depending on
        dragCorners(g.datum(), bb0, m);
        // Set the coordinates
        setCoordsData(g.datum());
      };

      const end = function () {
        // Undo formatting
        self.svg.style('cursor', 'default');
      };

      // return the drag container
      return d3.drag()
        .on('start', start)
        .on('drag', drag)
        .on('end', end);

    };

    // Make drag containers for each
    return {
      makeContainer: makeContainer
    };
  }

  // Append helper rectEdges and rectCorners to g
  function makeRectEdgeCorner() {
    // Adds edges and corners to rectangle for drag move and resize.

    // "Prototype" elements
    const proto = [
    // Rectangular edges
      g.append('rect')
        .attr('class', 'rectEdge cornerEdge ' + groupClass + debug)
        .attr('opacity', '0')
      ,

      // Circular corners - NWSE cursor
      g.append('rect')
        .attr('height', dbWidth)
        .attr('width', dbWidth)
        .attr('id', 'topright')
        .attr('class', 'rectCorner cornerEdge nwse ' + groupClass + debug)
        .attr('opacity', '0')
      ,

      // Circular corners - NESW cursor
      g.append('rect')
        .attr('height', dbWidth)
        .attr('width', dbWidth)
        .attr('id', 'topright')
        .attr('class', 'rectCorner cornerEdge nesw ' + groupClass + debug)
        .attr('opacity', '0')

    ];

    // Behaviors to attach to corners and edges
    const move = moveRect();
    const resize = resizeRect();

    // Create Edges
    clone('.rectEdge.' + groupClass)
      .classed('rectEdge-left', true)
      .call(move.drag);
    clone('.rectEdge.' + groupClass)
      .classed('rectEdge-right', true)
      .call(move.drag);
    clone('.rectEdge.' + groupClass)
      .classed('rectEdge-top', true)
      .call(move.drag);
    clone('.rectEdge.' + groupClass)
      .classed('rectEdge-bottom', true)
      .call(move.drag);

    // 박스 내부 드래그로도 이동 (가장자리와 동일 move 동작)
    r.call(move.drag);

    // Create Corners
    clone('.nwse.' + groupClass)
      .classed('rectCorner-topleft', true)
      .call(resize.makeContainer('topleft'));
    clone('.nesw.' + groupClass)
      .classed('rectCorner-topright', true)
      .call(resize.makeContainer('topright'));
    clone('.nesw.' + groupClass)
      .classed('rectCorner-botleft', true)
      .call(resize.makeContainer('botleft'));
    clone('.nwse.' + groupClass)
      .classed('rectCorner-botright', true)
      .call(resize.makeContainer('botright'));

    // Remove prototype elements from DOM
    proto.forEach((d, i) => {
      d.remove();
    });

    // Format size and shape of added objects.
    setCoordsData(g.datum());
  }
};

DefectDrawer.prototype.setActive = function (id, force_clear = false) {
  // Sets class to active for selected groups.
  let deactivate = false;

  // When should all other groups be deactivated?
  //  1.A If the ctrl key is not pressed
  //  1.B If the present element isn't already active
  //  (Use De Morgan's Rules for this one.)
  deactivate = deactivate || !(d3.event !== null && d3.event.sourceEvent.ctrlKey || d3.selectAll('g.' + id)?.classed('active'));
  //  2. If we didn't force it to be.
  deactivate = deactivate || force_clear;
  // If any of these conditions met, clear the active elements.
  if (deactivate) {
    this.svg.selectAll('g.active').classed('active', false);
  }

  // Add 'active' class to any 'g' element with id = id passed.
  d3.selectAll('g.' + id).classed('active', true);
};

DefectDrawer.prototype.makeInactiveRect = function(rectDis){
  const self = this;
  // 중복 append 방지
  if (self.inActiveRectG) {
    self.inActiveRectG.selectAll('*').remove();
  }
  // 화면 고정 오버레이(Vue)가 그릴 때는 SVG stroke 생략
  if (self.options.screenSpaceThermoHud) {
    return;
  }
  (rectDis || []).forEach(di => {
    self.inActiveRectG.append('rect')
      .attr('x', di.x)
      .attr('y', di.y)
      .attr('width', di.w)
      .attr('height', di.h)
      .attr('stroke', '#00ffff')
      .attr('stroke-width', 3)
      .attr('fill', 'none')
      .attr('opacity', 0.5)
      .attr('class', 'rect-sub inactive');
  });
};

// store의 기본값으로 사각형 설정
DefectDrawer.prototype.loadDefaultRectFromStore = function() {
  if (this.store && this.store.state.defect && this.store.state.defect.defectShapes) {
    const state = this.store.state.defect.defectShapes;
    this.Rect.x0 = state.x;
    this.Rect.y0 = state.y;
    this.Rect.width = state.width;
    this.Rect.height = state.height;

    // 사각형과 텍스트 위치 업데이트 (thermo_fn이 있는 경우에만)
    if (this.options.thermo_fn) {
      this.updateRectPosition();
    } else {
      // thermo_fn이 없는 경우 사각형 위치만 업데이트
      this.Rect.r
        .attr('x', this.Rect.x0)
        .attr('y', this.Rect.y0)
        .attr('width', this.Rect.width)
        .attr('height', this.Rect.height);
    }

    console.log('[DEFECT DRAWER] store 기본값으로 사각형 설정:', { x: state.x, y: state.y, width: state.width, height: state.height });
  } else {
    console.warn('[DEFECT DRAWER] store 또는 defectShapes가 없어서 기본값 사용 불가');
  }
};

// 초기 사각형으로 리셋하는 메서드
DefectDrawer.prototype.resetToDefaultRect = function() {
  console.log('[DEFECT DRAWER] 초기 사각형으로 리셋');

  // store의 기본값 사용
  this.loadDefaultRectFromStore();
};

// 사각형 위치 업데이트 메서드
DefectDrawer.prototype.updateRectPosition = function() {
  // 사각형 위치 업데이트
  this.Rect.r
    .attr('x', this.Rect.x0)
    .attr('y', this.Rect.y0)
    .attr('width', this.Rect.width)
    .attr('height', this.Rect.height);

  // 텍스트 위치 업데이트
  const textXPos = this.Rect.x0 + this.Rect.width + this.options.text_m;

  // 온도 데이터 다시 계산
  const thermo = this.options.thermo_fn ? this.options.thermo_fn({
    x: this.Rect.x0,
    y: this.Rect.y0,
    w: this.Rect.width,
    h: this.Rect.height
  }) : null;

  // 텍스트 내용 업데이트 (thermo가 null인 경우 처리)
  if (this.Text.maxT) {
    this.Text.maxT.text(`Max: ${thermo?.max || '-'}°C`);
    this.styleThermoLabel(this.Text.maxT);
  }
  if (this.Text.minT) {
    this.Text.minT.text(`Min: ${thermo?.min || '-'}°C`);
    this.styleThermoLabel(this.Text.minT);
  }
  if (this.Text.avrT) {
    this.Text.avrT.text(`Avg: ${thermo?.avr || '-'}°C`);
    this.styleThermoLabel(this.Text.avrT);
  }

  // 텍스트 위치 업데이트
  if (this.Text.maxT) this.Text.maxT.attr('x', textXPos);
  if (this.Text.minT) this.Text.minT.attr('x', textXPos);
  if (this.Text.avrT) this.Text.avrT.attr('x', textXPos);

  const textY = this.Rect.y0 + this.options.text_y_pos_corr;
  if (this.Text.maxT) this.Text.maxT.attr('y', textY);
  if (this.Text.minT) this.Text.minT.attr('y', textY);
  if (this.Text.avrT) this.Text.avrT.attr('y', textY);
  this.setLabelAnchor(textXPos, textY, thermo);
};

export default DefectDrawer;
